import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter, map, shareReplay, startWith, throttleTime} from 'rxjs/operators';
import {wwData$} from './worker-data';
import {isUtaSpot$} from './uta-state';
import type {UAssetsSpot, USpotWallets, USpotPTDiscountState} from '@px/ws-data';

export const spotTotalAssets$ = wwData$.pipe(
  filter((o) => o.type === 'wallet-assets'),
  map((o: UAssetsSpot) => o.data.assets),
  startWith(initAssets()),
  shareReplay(1)
);

const innerWallets$ = wwData$.pipe(
  filter((o) => o.type === 'spot-wallets'),
  map((o: USpotWallets) => o.data.wallets),
  throttleTime(50),
  shareReplay(1)
);

export const wallets$ = combineLatest({innerWallets: innerWallets$, isUtaSpot: isUtaSpot$}).pipe(
  filter(({isUtaSpot}) => !isUtaSpot),
  map(({innerWallets}) => innerWallets),
  startWith([]),
  shareReplay(1)
);

export const invalidWallets$ = wwData$.pipe(
  filter((o) => o.type === 'spot-invalid-wallets'),
  map((o: USpotWallets) => o.data.wallets),
  startWith([]),
  throttleTime(50),
  shareReplay(1)
);

// 现货网格总资产
export const spotBotsTotalAssets$ = wwData$.pipe(
  filter((o) => o.type === 'spot-trading-bots-total-assets'),
  map((o: UAssetsSpot) => o.data.assets),
  startWith(initAssets()),
  shareReplay(1)
);

export const spotPTDiscountState$ = new BehaviorSubject<boolean>(false);

wwData$
  .pipe(
    filter((o) => o.type === 'spot-pt-discount-state'),
    map((o: USpotPTDiscountState) => o.data.state)
  )
  .subscribe((state) => spotPTDiscountState$.next(state));

function initAssets() {
  const BTC_PRECISION = 8;
  const USD_PRECISION = 2;
  return {
    isInit: true,
    btcEv: 0,
    btc: (0).toFixed(BTC_PRECISION),
    usdEv: 0,
    usd: (0).toFixed(USD_PRECISION),
    money: (0).toFixed(USD_PRECISION),
    usdtEv: 0,
    usdt: (0).toFixed(USD_PRECISION),
  };
}
